module.exports = __webpack_public_path__ + "img/bg_question_des_3.026a5c0d.jpg";